import React from "react";
import { Link } from "react-router";

const BlogCard = (props) => {
  const Datex = (tarik) => {
    const date = new Date(tarik);
    const ddMmYyyy = `${date.getUTCDate().toString().padStart(2, "0")}-${(
      date.getUTCMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getUTCFullYear()}`;
    return ddMmYyyy;
  };

  const convertBlocksToHtml = (blocks) => {
    // If blocks is not an array, check if it is an object with a "blocks" property.
    if (!Array.isArray(blocks)) {
      if (blocks && Array.isArray(blocks.blocks)) {
        blocks = blocks.blocks;
      } else {
        console.error("Expected an array for blocks, but got:", blocks);
        return "";
      }
    }
    return blocks
      .map((block) => {
        switch (block.type) {
          case "paragraph":
            return `<p>${block.data.text}</p>`;
          case "header":
            return `<h${block.data.level}>${block.data.text}</h${block.data.level}>`;
          case "image":
            return `<img src="${block.data.file.url}" alt="${block.data.caption}" />`;
          case "list":
            const tag = block.data.style === "ordered" ? "ol" : "ul";
            return `<${tag}>${block.data.items
              .map((item) => `<li>${item}</li>`)
              .join("")}</${tag}>`;
          case "quote":
            return `<blockquote>${block.data.text}</blockquote>`;
          case "code":
            return `<pre><code>${block.data.code}</code></pre>`;
          default:
            return "";
        }
      })
      .join("");
  };

  const stripHtml = (html) => {
    // Remove <img> tags completely
    html = html.replace(/<img[^>]*>/g, "");
    // Remove all other HTML tags
    html = html.replace(/\[object Object\]/g, "").replace(/\{.*?\}/g, "");
    return html.replace(/<[^>]*>/g, "");
  };

  const addLineBreaks = (text, charLimit = 50) => {
    return text.replace(/(\S{50,})/g, (match) => {
      return match.replace(new RegExp(`(.{${charLimit}})`, "g"), "$1<br>");
    });
  };

  const truncateText = (text, wordLimit, charLimit = 50) => {
    let plainText = "";
    // If text is a string (e.g. for the title), use it directly.
    if (typeof text === "string") {
      plainText = text;
    } else {
      // Otherwise assume text is an object with a blocks array or is an array already.
      plainText = stripHtml(convertBlocksToHtml(text)).trim();
    }
    let words = plainText.split(/\s+/);
    if (words.length > wordLimit) {
      plainText = words.slice(0, wordLimit).join(" ") + "...";
    }
    return addLineBreaks(plainText, charLimit);
  };

  return (
    <>
      <div className="xb-blog xb-hover-zoom pos-rel ul_li">
        <div className="xb-item--img">
          <img src={props.content.homeImage} alt="" />
        </div>
        <div className="xb-item--inner ul_li">
          <div className="xb-item--author">
            <div className="xb-item--avatar">
              <img src="static/media/assets/img/blog/blog-icon_01.jpg" alt="" />
            </div>
            <h3 className="xb-item--name">
              <span>By</span>: {props.content.creator === 'creator' || !props.content.creator ? 'Admin' : props.content.creator}
            </h3>
            <h5 className="xb-item--date">{Datex(props.content.date)}</h5>
          </div>
          <div className="xb-item--holder">
            <h2 className="xb-item--title">
              {truncateText(props.content.title, 15)}
            </h2>
            <p
              className="xb-item--content"
              dangerouslySetInnerHTML={{
                __html: props.content.excerpt 
                  ? addLineBreaks(props.content.excerpt, 50)
                  : props.content.content 
                    ? truncateText(props.content.content, 25)
                    : "No preview available",
              }}
            ></p>
          </div>
        </div>
        <Link
          className="xb-overlay"
          to={"/preview/" + `${props.content.urlHeading}`}
        ></Link>
        <div style={{ width: "100%", position: "relative", zIndex: "10" }}>
          <div
            className="flex"
            style={{
              padding: "8px",
              display: "flex",
              gap: "10px",
              width: "100%",
              flexDirection: "row-reverse",
            }}
          ></div>
        </div>
      </div>
    </>
  );
};

export default BlogCard;
